// Small red count pill for unread signals - used on the Channels nav item
// (aggregate, see StoreContext's unreadTotal) and on each channel-list row
// (per-channel, unreadByChannel[nickname]). The server caps a single
// channel's count at 99 (signal/signal.ts unreadDisplayCap); the nav total
// can exceed that, hence the "99+" clamp here rather than server-side.
export function UnreadBadge({ count, className = '' }: { count: number; className?: string }) {
  if (!count || count < 1) return null;
  return (
    <span
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold leading-none tabular-nums ${className}`}
      aria-label={`${count} unread`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
